import type { ComponentType } from 'react';
import * as PlusModule from '@abi-labs-hexa/web-v2/core/icons/Plus';
import * as SaveModule from '@abi-labs-hexa/web-v2/core/icons/Save';
import * as TrashModule from '@abi-labs-hexa/web-v2/core/icons/Trash';
import * as ArrowLeftModule from '@abi-labs-hexa/web-v2/core/icons/ArrowLeft';

type IconModule = {
  default?: ComponentType | IconModule;
};

const getIcon = (iconModule: IconModule): ComponentType => {
  let current: ComponentType | IconModule | undefined = iconModule;

  while (current && typeof current === 'object' && 'default' in current) {
    current = current.default;
  }

  return current as ComponentType;
};

export const Plus = getIcon(PlusModule as IconModule);
export const Save = getIcon(SaveModule as IconModule);
export const Trash = getIcon(TrashModule as IconModule);
export const ArrowLeft = getIcon(ArrowLeftModule as IconModule);
